import { Injectable } from '@angular/core';

@Injectable()
export class SearchRepositoryService {
   searchDowngrader
   static injectName = 'searchService';
}